<!--  -->
<template>
  <div class='home'>
    <div>
      <img src="../assets/bj_01.jpg" alt="">
      <img src="../assets/bj_02.jpg" alt="">
      <img src="../assets/bj_03.jpg" alt="">
      <img src="../assets/bj_04.jpg" alt="">
    </div>
    <div class="disc">
      <div class="pan">
        <img src="../assets/pan.png" alt="">
        <ul class="prize_list">
          <li v-for="(item,index) in prize_list" :key="index">
            <p>{{item.name}}</p>
            <img :src="item.imageUrl" alt="">
          </li>
        </ul>
        <div class="arrow">
          <button @click="choujiang" :style="{transform:rotate_angle,transition:rotate_transition}"><img src="../assets/arrow.png" alt=""></button>
        </div>
      </div>
      <p class="txt">抽奖次数剩余：{{lottery_ticket}}</p>
      <button class="btn" @click="me"><img src="../assets/btn.png" alt=""></button>
    </div>
    <div class="rule">
      <img class="txt" src="../assets/rule.png" alt="">
      <img class="flower" src="../assets/flower.png" alt="">
    </div>
    <div class="mask" v-show="show">
      <div class="box2">
        <img src="../assets/mask.png" alt="">
        <div class="copywriting nothing" v-show="WinOrNot">
          <img src="../assets/face.png" alt="">
          <p class="txt1">谢谢参与</p>
          <p class="txt2">哇哦，大奖与您擦肩而过~</p>
          <button class="btn" @click="show=false">知道了</button>
        </div>
        <div class="copywriting nothing" v-show="!WinOrNot">
          <img :src="prizeImg" alt="">
          <p class="txt1">中奖啦~</p>
          <p class="txt2">抽中奖品可在“我的抽奖记录”查看</p>
          <button class="btn" @click="show=false">知道了</button>
        </div>
      </div>
    </div>
    <pop v-show="popshow" :txt="poptxt"></pop>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import pop from "../components/pop";
import { API_1, Global } from "../conf/api";
export default {
  //import引入的组件需要注入到对象中才能使用
  name: "Home",
  components: {
    pop,
  },
  data() {
    //这里存放数据
    return {
      userId: "",
      popshow: false,
      poptxt: "您已经没有抽奖次数了",
      show: false,
      prizeImg: "", //中奖奖品图片
      prizeName: "", //中奖奖品名称
      prizeId: "", //中奖奖品Id
      WinOrNot: true, //是否中奖文案
      easejoy_bean: 0, //金豆
      lottery_ticket: 0, //抽奖次数
      prize_list: [],
      toast_control: false, //抽奖结果弹出框控制器
      hasPrize: false, //是否中奖
      start_rotating_degree: 0, //初始旋转角度
      rotate_angle: 0, //将要旋转的角度
      start_rotating_degree_pointer: 0, //指针初始旋转角度
      rotate_angle_pointer: 0, //指针将要旋转的度数
      rotate_transition: "transform 6s ease-in-out", //初始化选中的过度属性控制
      rotate_transition_pointer: "transform 12s ease-in-out", //初始化指针过度属性控制
      click_flag: true, //是否可以旋转抽奖
      index: 0, //中奖key
      prizeIndex: 0
    };
  },

  methods: {
    me() {
      //去中奖记录
      this.$router.push({
        name: "record",
        query: {
          id: this.userId,
        },
      });
    },
    prizeList() {
      let params = {};
      this.axios
        .get(API_1 + Global.list, {
          params: params,
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.prize_list = res.data.data;
            this.prize_list.forEach((item,index) => {
              if(item.id == -1) {
                this.prizeIndex = index;
              }
            })
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    choujiang() {
      //抽奖
      if (!this.click_flag) return;
      let params = {
        userID: this.userId,
        userName: this.userName,
      };
      this.axios
        .get(API_1 + Global.draw, {
          params: params,
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.rotate_handle(res.data.data);
          } else if (res.data.code == 500) {
            this.poptxt = "您已经没有抽奖次数了";
            this.popshow = true;
            setTimeout(() => {
              this.popshow = false;
            }, 2000);
          }
          this.getNum();
        })
        .catch((res) => {
          console.log(res);
        });
    },
    getNum() {
      //s剩余抽奖次数
      let params = {
        userID: this.userId,
      };
      this.axios
        .get(API_1 + Global.getPrizeNum, {
          params: params,
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.lottery_ticket = res.data.data;
          } else {
            this.popshow = true;
            this.poptxt = "数据加载失败，请返回上级页面";
            setTimeout(() => {
              this.popshow = false;
            }, 2000);
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },

    // tcFun() {

    //     this.promptDialogVisible = true;
    // },

    //获取中奖数据
    rotate_handle(num) {
      this.index = num;
      // this.$Api.redeemTaskWordPrize().then(resp => {
      //模拟后台返回数据
      // let resp = {
      //     prizeLevel: 1,
      //     bonus: 1000,
      //     txt: "铂金"
      // };
      // if (resp) {
      //     // 如果此奖项在转盘中有两项以上，随机转动到其中一项
      //     if (resp.prizeLevel == 1) { //青铜
      //         let arr = [1, 3, 7];
      //         let i = Math.floor(Math.random() * arr.length + 1) - 1;
      //         this.index = arr[i]; //指定每次旋转到的奖品下标

      //     } else if (resp.prizeLevel == 2) { //白银
      //         let arr = [5, 9];
      //         let i = Math.floor(Math.random() * arr.length + 1) - 1; //随机数

      //         this.index = arr[i]; //指定每次旋转到的奖品下标
      //     } else if (resp.prizeLevel == 3) { //黄金
      //         let arr = [2, 8];
      //         let i = Math.floor(Math.random() * arr.length + 1) - 1;

      //         this.index = arr[i]; //指定每次旋转到的奖品下标

      //     } else if (resp.prizeLevel == 4) { //铂金

      //         let arr = [1, 6];
      //         let i = Math.floor(Math.random() * arr.length + 1) - 1;

      //         this.index = arr[i]; //指定每次旋转到的奖品下标
      //     } else if (resp.prizeLevel == 5) { //钻石

      //         this.index = 4
      //     }

      this.rotating();

      // });
    },
    rotating() {
      var type = 0; // 默认为 0  转盘转动 1 箭头和转盘都转动(暂且遗留)
      var during_time = 5; // 默认为1s
      var random = Math.floor(Math.random() * 7); // eslint-disable-line no-unused-vars
      var result_index;
      switch (this.index) {
        case "1":
          result_index = 0;
          break;
        case "2":
          result_index = 1;
          break;
        case "3":
          result_index = 2;
          break;
        case "4":
          result_index = 3;
          break;
        case "5":
          result_index = 6;
          break;
        case "6":
          result_index = 5;
          break;
        case "-1":
          // result_index = 4;
          result_index = this.prizeIndex
          break;
        case "7":
          result_index = 7;
          break;
      }
      // 最终要旋转到哪一块，对应prize_list的下标
      // var result_angle = [337.5, 292.5, 247.5, 202.5, 157.5, 112.5, 67.5, 22.5]; //最终会旋转到下标的位置所需要的度数
      var result_angle = [0, 43, 88, 130, 177, 225, 268, 317]; //最终会旋转到下标的位置所需要的度数
      var rand_circle = 6; // 附加多转几圈，2-3
      this.click_flag = false; // 旋转结束前，不允许再次触发
      if (type == 0) {
        // 转动盘子
        var rotate_angle =
          this.start_rotating_degree +
          rand_circle * 360 +
          result_angle[result_index] -
          (this.start_rotating_degree % 360);
        // this.start_rotating_degree = rotate_angle;
        this.rotate_angle = "rotate(" + rotate_angle + "deg)"; //转动的角度总和 = 圈数
        this.start_rotating_degree = rotate_angle; //记录此次角度 便于下次转动累计
        // // //转动指针
        // this.rotate_angle_pointer = "rotate("+this.start_rotating_degree_pointer + 360*rand_circle+"deg)";
        // this.start_rotating_degree_pointer =360*rand_circle;
        var that = this;
        // 旋转结束后，允许再次触发
        setTimeout(function () {
          that.show = true;
          if (that.index == -1 || that.index == -2) {
            that.WinOrNot = true;
          } else {
            that.prize_list.map((val) => {
              if (val.id == that.index) {
                that.prizeImg = val.imageUrl;
              }
            });
            that.WinOrNot = false;
          }
          that.click_flag = true;
        }, during_time * 1000 + 1500); // 延时，保证转盘转完
      } // else {
      //
      //}
    },
  },
  created() {
    this.userId = this.$route.query.userId;
    this.userName = this.$route.query.userName;
    this.prizeList();
    this.getNum();
  },
  mounted() {},
};
</script>
<style>
.home .mask .box2 .copywriting .btn{ padding:0 !important}
</style>
<style lang="scss" scoped>
.home {
  position: relative;
  width: 100%;

  button {
    background: none;
  }

  .disc {
    position: absolute;
    top: 22%;
    left: 0;

    .pan {
      width: 90%;
      margin: 0 auto;

      .prize_list {
        li {
          position: absolute;
          z-index: 2;
          font-size: 3vw;
          color: #ffae00;
          width: 18vw;

          &:nth-child(1) {
            top: 9%;
            left: 41%;
            transform: rotate(0deg);
          }

          &:nth-child(2) {
            top: 15%;
            left: 60%;
            transform: rotate(53deg);
          }

          &:nth-child(3) {
            top: 31%;
            left: 67%;
            transform: rotate(93deg);
          }

          &:nth-child(4) {
            top: 46%;
            left: 60%;
            transform: rotate(139deg);
          }

          &:nth-child(5) {
            top: 53%;
            left: 41%;
            transform: rotate(180deg);
          }

          &:nth-child(6) {
            top: 47%;
            left: 20%;
            transform: rotate(225deg);
          }

          &:nth-child(7) {
            top: 30%;
            left: 15%;
            transform: rotate(270deg);
          }

          &:nth-child(8) {
            top: 15%;
            left: 22%;
            transform: rotate(307deg);
          }

          img {
            width: 13vw;
          }

          p {
            margin-bottom: 5%;
          }
        }
      }

      .arrow {
        width: 23%;
        position: absolute;
        top: 25%;
        left: 38%;
        font-weight: 500;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-content: center;

        button {
          transform-origin: center 57%;
        }
      }
    }

    .txt {
      margin-top: 5%;
      color: #fff;
      font-size: 5vw;
    }

    .btn {
      width: 70%;
      margin-top: 5%;
    }
  }

  .rule {
    margin-top: 7%;
    position: absolute;
    left: 0;
    bottom: 0;

    .txt {
      margin-bottom: 14%;
    }

    .flower {
      position: absolute;
      z-index: 10000;
      left: 0;
      bottom: 0;
    }
  }

  .mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background: rgba(0, 0, 0, 0.7);
    z-index: 99990000000000;
    height: 100%;
    color: #fffcf3;

    .box2 {
      position: relative;
      margin-top: 30%;

      img {
        width: 80%;
      }

      .copywriting {
        position: absolute;
        width: 100%;
        top: 13%;
        left: 0;

        img {
          width: 17vw;
          margin-bottom: 3%;
        }

        .txt1 {
          font-size: 6vw;
          margin-bottom: 5%;
        }

        .txt2 {
          font-size: 3vw;
          margin-bottom: 12%;
        }

        .btn {
          border-radius: 36px;
          background: #f7c144;
          color: #fff;
          width: 60%;
          margin: 0 auto;
          padding: 3% 0;
          margin-bottom: 10%;
          font-size: 4vw;
        }
      }
    }
  }
}

//@import url(); 引入公共css类
</style>
